export default __webpack_public_path__ + "static/media/spheres-other.de353765.wav";